import { useEffect, useState } from 'react';
import { Layout, Drawer } from 'antd';
import NavBar from './NavBar';
import Sidebar from './Sidebar';
import FooterLayout from './Footer';
import './css/index.css'
const { Content } = Layout;

const LayoutIndex = (props) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
 

  return (
    <div className="app-layout">
      <Drawer
        title={null}
        placement="left"
        closable={false}
        onClose={() => setIsSidebarOpen(false)}
        open={isSidebarOpen}
        className="d-md-none d-lg-none w-60"
        bodyStyle={{ padding: 0 }}
      >
        <Sidebar setIsSidebarOpen={setIsSidebarOpen} />
      </Drawer>

      <div className="app-body">
        
        <aside className={`sidebar-desktop ${isSidebarCollapsed ? 'collapsed' : ''}`}>
          <Sidebar
            sidebarOpen = {isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
            isSidebarCollapsed={isSidebarCollapsed}
            setIsSidebarCollapsed={setIsSidebarCollapsed}
          />
        </aside>
        

        <div className="main-content">
          <header className="main-header">
            <NavBar onOpenSidebar={() => setIsSidebarOpen(true)} />
          </header>

          <main className="main-area">
            {props.children}
          </main>

          <footer className="main-footer">
            <FooterLayout />
          </footer>
        </div>
      </div>
    </div>

  );
}

export default LayoutIndex;
